module.exports = __webpack_public_path__ + "img/logo_mastercard1.ac37cf6e.png";